import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { AbsoluteModelPath, AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { setToModel, setToModelBatch } from "../../../Engine/ActionCreators/AllActionCreators";
import { ModelHunk } from "../../../Engine/Core/ModelStoring/ModelHunk";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withViewModelSelect } from "../../withViewModelSelect";
import { emptyNidusEntryId, NidusEntry } from "../../../../../Common/NidusClient/INidusClient";
import { PathResolver, withResolvePaths } from "../../withResolvePaths";

import { ReferencedFields } from "./ReferencedFields";

export interface ReferencedFieldsContainerProps {
    bindingPath: AbsoluteResolvedModelPath;
    mapping: Array<[string, AbsoluteModelPath]>;
    viewModelSelect: ViewModelSelect;
    resolvePath: PathResolver;
}

const mapStateToProps = (state: FullFormState, props: ReferencedFieldsContainerProps) => {
    const referencedEntryId = props.viewModelSelect.pathViewModel(state, props.bindingPath).referencedId;
    return {
        referencedEntryId: referencedEntryId,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, props: ReferencedFieldsContainerProps) => {
    const resolvePath = props.resolvePath;

    return {
        onApplyReferencedValue: (nidusEntry: undefined | NidusEntry) => {
            if (nidusEntry == undefined) {
                const update = new ModelHunk();
                for (const path of props.mapping.map(x => x[1])) {
                    update.set(resolvePath(path), { value: "" });
                }
                update.set(props.bindingPath, { referencedId: emptyNidusEntryId() });
                dispatch(setToModelBatch(update));
            } else {
                const update = new ModelHunk();
                for (const [referenceFieldName, path] of props.mapping) {
                    update.set(resolvePath(path), { value: nidusEntry.data[referenceFieldName] });
                }
                update.set(props.bindingPath, { referencedId: nidusEntry.id });
                dispatch(setToModelBatch(update));
            }
        },
        onRemoveReference: () => {
            dispatch(setToModel(props.bindingPath, "referencedId", ""));
        },
    };
};

export const ReferencedFieldsContainer = withResolvePaths(
    withViewModelSelect(connect(mapStateToProps, mapDispatchToProps)(ReferencedFields))
);
